import ApiResourceRequest from './ApiResourceRequest';
import { required } from '../../utils/helpers';
import ListingResponse from './ListingResponse';
import Pager from '../helpers/Pager';

export class LookupValueRequest extends ApiResourceRequest {
  get apiResource() {
    return 'internal-requests/lookup-values';
  }

  get routes() {
    return {
      ...super.routes,
      SEARCH_GET: `${this.apiRoute}/search/{part}`,
    };
  }

  async get(type, projectId, pager = new Pager(), query = {}) {
    pager && Pager.check(pager);
    required({ type, projectId });
    const queryString = this.buildQueryString(
      this.getPaginationParams(pager),
      this.getRelationParams(query.relations),
      this.getFilterParams(query.filter),
      this.getOrderParams(query.order),
      `&type=${encodeURIComponent(type)}&projectId=${encodeURIComponent(
        projectId
      )}`
    );

    const response = await this.request(
      'GET',
      `${this.routes.GET}${queryString}`
    );

    return new ListingResponse(response?.data);
  }

  async searchGet(part, type, projectId, pager = new Pager(), query = {}) {
    pager && Pager.check(pager);
    required({ part, type, projectId });
    const queryString = this.buildQueryString(
      this.getPaginationParams(pager),
      this.getRelationParams(query.relations),
      this.getFilterParams(query.filter),
      this.getOrderParams(query.order),
      `&type=${encodeURIComponent(type)}&projectId=${encodeURIComponent(
        projectId
      )}`
    );

    const response = await this.request(
      'GET',
      this.routes.SEARCH_GET.replace('{part}', part) + queryString
    );

    return new ListingResponse(response?.data);
  }

  async create(attributes) {
    const response = await this.request('POST', this.routes.CREATE, attributes);

    return response.data;
  }
}

export const lookupValueRequest = new LookupValueRequest();
